import React from 'react';

import ReceptorSelected from './ReceptorSelected';
import ReceptorSuggestionsList from './ReceptorSuggestionsList';

class ReceptorSuggestions extends React.Component {
  handleOnSelect = (item) => {
    this.props.onSelect(item);
  };

  render() {
    const { autoFocus, data = {} } = this.props;

    return (
      <>
        {!data.rfc && (
          <div>
            <ReceptorSuggestionsList
              autoFocus={autoFocus}
              onSelect={this.handleOnSelect}
            />
          </div>
        )}

        {!!data.rfc && <ReceptorSelected data={data} />}
      </>
    );
  }
}

export default ReceptorSuggestions;
